













































import { Component, Vue, Watch } from 'vue-property-decorator';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import * as api from '../../../api/statistic-analysis';
import ParktimeDistribution from './components/parktime-distribution.vue';
import ParktimeStatistics from './components/parktime-statistics.vue';
import ParktimeTop from './components/parktime-top.vue';

@Component({
  name: 'ParkTime',
  components: {
    ParkingLotSearch,
    ParktimeDistribution,
    ParktimeStatistics,
    ParktimeTop
  }
})
export default class ParkTime extends Vue {
  public filterParam: any = {
    startTime: '',
    endTime: ''
  };

  // 选择的车场
  selectParkIds: Array<string> = [];

  getPopupContainer() {
    // @ts-ignore hack
    return this.$refs.panel['$el'];
  }

  clear({ defaultParkIdList }) {
    this.customTime = [];
    this.selectParkIds = defaultParkIdList;
    this.timeRangeType = '01';
  }

  search() {
    this.fetchData();
  }

  timeQuickButtons: any[] = [
    { value: '01', text: '近7天' },
    { value: '02', text: '近1月' },
    { value: '03', text: '自定义' }
  ];

  // 选择的时间范围
  timeRangeType: String = '01';

  onTimeRangeTypeChange() {
    if (this.timeRangeType !== '03') {
      this.customTime = [];
      this.filterParam.startTime = '';
      this.filterParam.endTime = '';
      this.fetchData();
    }
  }

  // 自定义时间
  customTime: any[] = [];
  customTimeFormat: string = 'YYYY-MM-DD';
  customTimeMode: string[] = ['date', 'date'];

  onCustomTimeChange(date: any, dateString: any) {
    const [startTime, endTime] = date;
    this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
    this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
  }

  onCustomTimeChange2(date: any, dateString: any) {
    const [startTime, endTime] = date;
    this.customTime = [startTime, endTime];
    this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
    this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
  }

  distributionData: any[] = [];
  statisticsData: any[] = [];
  topData: any[] = [];

  fetchData() {
    const params = {
      parkId: this.selectParkIds.join(','),
      type: this.timeRangeType,
      ...this.filterParam
    };
    api
      .getParktimeDistribution(params)
      .then(res => {
        console.log(res.data);
        this.distributionData = res.data;
      })
      .catch(() => {});
    api
      .getParktimeTop(params)
      .then(res => {
        console.log(res.data);
        this.topData = res.data;
      })
      .catch(() => {});
    api
      .getParktimeAverage(params)
      .then(res => {
        console.log(res.data);
        this.statisticsData = res.data;
      })
      .catch(() => {});
  }

  mounted() {
    this.fetchData();
  }
}
